import { QueryParamValue } from './index';
import { getQueryParams } from './getQueryParams';

/**
 * Updates URL parameters
 * @param key - Parameter key
 * @param newValue - New parameter value
 */
export function updateUrlParams(key: string, newValue: QueryParamValue): void {
  if (typeof window === 'undefined') return;

  const params = getQueryParams();
  if (newValue === null || newValue === '') {
    delete params[key];
  } else {
    params[key] = newValue;
  }

  const urlParams = new URLSearchParams(params);
  const newURL = `${window.location.pathname}${
    urlParams.toString() ? '?' + urlParams.toString() : ''
  }`;

  window.history.replaceState({}, '', newURL);
}